// 通过gateway分发，业务服务在SERVERS中，通常维护SERVERS即可
export default {
  SERVERS: {
    koala: "/world-koala",
    passport: "/world-passport",
    user: "/world-user"
  },
  // local
  DEV: {
    gateway: "//dev-gateway.worldfarm.com"
  },
  // qa
  QA: {
    gateway: "//qa-gateway.worldfarm.com"
  },
  PROD: {
    gateway: "//gateway.worldfarm.com"
  }
};
